import { ProgressStages } from "@/components/ProgressStages";

// A carrier's quote, while it's under way (BRK-S369; Nav, 2026-10-16:
// "we should display loading screen so to indicate that we are fetching
// carrier questions or whatever works best for the process"): its stages, as
// Submit's progress screen shows its own. It sits in the quote popup, not in
// a dialog over it, since the popup can close and the run goes on (BRK-S347).
// A stage is ticked only once PMS has said so: the questions read, the set
// complete, the price back. A carrier asked on the WC wizard's last step
// (BRK-S393) has only its price to wait for.

export function QuoteProgress({
  carrier,
  at,
  nothingToAnswer = false,
  withQuestions = true,
}: {
  carrier: string;
  /** 0 while its questions load, 2 while it prices. */
  at: 0 | 2;
  /** The carrier had nothing to ask, so its middle stage says so. */
  nothingToAnswer?: boolean;
  /** False when its questions were answered elsewhere: the price alone. */
  withQuestions?: boolean;
}) {
  const quote = `Getting ${carrier}’s quote`;
  const stages = withQuestions
    ? [
        `Getting ${carrier}’s questions`,
        nothingToAnswer ? "Nothing to answer" : "Answering them",
        quote,
      ]
    : [quote];
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-brk-border bg-brk-panel p-4">
      <ProgressStages stages={stages} at={withQuestions ? at : 0} />
      <p className="text-sm text-brk-dim">
        {at === 2
          ? `${carrier} is pricing — this can take up to a minute. You can close this: its card shows the quote when it’s back.`
          : "This takes a moment."}
      </p>
    </div>
  );
}
